import { render, staticRenderFns } from "./DocumentStatus.vue?vue&type=template&id=43696f92&scoped=true"
import script from "./DocumentStatus.vue?vue&type=script&lang=js"
export * from "./DocumentStatus.vue?vue&type=script&lang=js"
import style0 from "./DocumentStatus.vue?vue&type=style&index=0&id=43696f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43696f92",
  null
  
)

export default component.exports